import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { useProduct } from '~/composables/_next/useProduct';
import CardRatingAndReviews from '~/components/Organisms/CardRatingsAndReviewsGraphql.vue';
import NativeCarousel from '~/components/Molecules/NativeCarousel.vue';
import useRightPath from '~/composables/useRightPath';
export default /*#__PURE__*/_defineComponent({
  __name: 'BlockRatingsAndReviewsGraphql',
  props: {
    slidesCollection: {
      type: Object,
      default: function _default() {}
    },
    title: {
      type: String,
      default: ''
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app;
    var _useProduct = useProduct('BlockRatingsAndReviews'),
      searchRatingAndReviewProducts = _useProduct.searchRatingAndReviewProducts,
      products = _useProduct.products;
    var _useRightPath = useRightPath(),
      getProductPrefix = _useRightPath.getProductPrefix;
    var slides = computed(function () {
      var _props$slidesCollecti;
      return ((_props$slidesCollecti = props.slidesCollection) === null || _props$slidesCollecti === void 0 ? void 0 : _props$slidesCollecti.items) || [];
    });
    var allProductsIds = computed(function () {
      var _slides$value$map;
      var listOfProductsIds = ((_slides$value$map = slides.value.map(function (slide) {
        return slide.productLink;
      })) === null || _slides$value$map === void 0 ? void 0 : _slides$value$map.flat()) || [];
      return _toConsumableArray(new Set(listOfProductsIds));
    });
    var slideProducts = computed(function () {
      return slides.value.filter(function (slideProduct) {
        return products.value.map(function (product) {
          return getProductSku(product);
        }).includes(slideProduct.productLink);
      });
    });
    function getProductSku(product) {
      var _product$masterData, _product$masterData$c, _product$masterData$c2;
      return product === null || product === void 0 ? void 0 : (_product$masterData = product.masterData) === null || _product$masterData === void 0 ? void 0 : (_product$masterData$c = _product$masterData.current) === null || _product$masterData$c === void 0 ? void 0 : (_product$masterData$c2 = _product$masterData$c.masterVariant) === null || _product$masterData$c2 === void 0 ? void 0 : _product$masterData$c2.sku;
    }

    /**
     * Gets the product link.
     *
     * @param      {string}  productSku  The product sku
     * @return     {string}  The product link.
     */
    function getProductLink(productSku) {
      var product = products.value.find(function (product) {
        var _product$masterData2, _product$masterData2$, _product$masterData2$2;
        return (product === null || product === void 0 ? void 0 : (_product$masterData2 = product.masterData) === null || _product$masterData2 === void 0 ? void 0 : (_product$masterData2$ = _product$masterData2.current) === null || _product$masterData2$ === void 0 ? void 0 : (_product$masterData2$2 = _product$masterData2$.masterVariant) === null || _product$masterData2$2 === void 0 ? void 0 : _product$masterData2$2.sku) === productSku;
      });
      if (product) {
        var _product$masterData3, _product$masterData3$;
        return app.localePath("".concat(getProductPrefix(), "/").concat(product === null || product === void 0 ? void 0 : (_product$masterData3 = product.masterData) === null || _product$masterData3 === void 0 ? void 0 : (_product$masterData3$ = _product$masterData3.current) === null || _product$masterData3$ === void 0 ? void 0 : _product$masterData3$.slug));
      }
      return null;
    }
    useLazyAsyncData('component-organism-blockRatingsAndReviewsGraphql', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(products.value.length > 0)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", true);
          case 2:
            _context.next = 4;
            return searchRatingAndReviewProducts({
              skus: allProductsIds.value
            });
          case 4:
            return _context.abrupt("return", true);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    return {
      __sfc: true,
      props: props,
      app: app,
      searchRatingAndReviewProducts: searchRatingAndReviewProducts,
      products: products,
      getProductPrefix: getProductPrefix,
      slides: slides,
      allProductsIds: allProductsIds,
      slideProducts: slideProducts,
      getProductSku: getProductSku,
      getProductLink: getProductLink,
      CardRatingAndReviews: CardRatingAndReviews,
      NativeCarousel: NativeCarousel
    };
  }
});